document.addEventListener('click', function (e) {
  const img = e.target.closest('.size-chart img');
  if (!img) return;

  const overlay = document.createElement('div');
  overlay.className = 'size-chart-zoom-overlay';

  const zoomImg = document.createElement('img');
  zoomImg.src = img.src;

  overlay.appendChild(zoomImg);
  document.body.appendChild(overlay);

  overlay.addEventListener('click', () => {
    overlay.remove();
  });
});